import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ReportsState {
  error?: string
  isFetching: { BPU: boolean; CPU: boolean; K8P: boolean }
  reports: { BPU?: any; CPU?: any; K8P?: any }
}

const initialState: ReportsState = {
  error: null,
  isFetching: { BPU: false, CPU: false, K8P: false },
  reports: { BPU: null, CPU: null, K8P: null },
}

const slice = createSlice({
  name: 'Reports',
  initialState,
  reducers: {
    fetchingReport(state, action: PayloadAction<string>) {
      state.error = null
      state.isFetching[action.payload] = true
      state.reports[action.payload] = null
    },
    fetchingReportSuccess(
      state,
      action: PayloadAction<{ program: string; reportData: any }>,
    ) {
      state.error = null
      state.isFetching[action.payload.program] = false
      state.reports[action.payload.program] = action.payload.reportData
    },
    fetchingReportError(
      state,
      action: PayloadAction<{ error: any; program: string }>,
    ) {
      state.error = action.payload.error
      state.isFetching[action.payload.program] = false
    },
    deleteReportsSuccess(state) {
      state.error = null
      state.isFetching = { BPU: false, CPU: false, K8P: false }
      state.reports = { BPU: null, CPU: null, K8P: null }
    },
  },
})

export const actions = slice.actions
export default slice.reducer

